import './index.css'
import {Component} from 'react'
import {MdSearch, MdHome, MdPlaylistAdd} from 'react-icons/md'
import {FaFirefoxBrowser} from 'react-icons/fa'
import {SiYoutubegaming} from 'react-icons/si'
import {GiCancel} from 'react-icons/gi'
import Cookies from 'js-cookie'
import {Link, Route, Switch} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import Headers from '../Headers'
import TrendingRoute from '../TrendingRoute'
import GamingRoute from '../GamingRoute'
import SavedVideos from '../SavedVideos'

class HomeRoute extends Component {
  state = {
    videosList: [],
    searchInput: '',
    apiStatus: 'INITIAL',
    isBannerVisible: true,
    isDarkTheme: false,
  }

  componentDidMount() {
    this.getData()
  }

  toggleTheme = () => {
    this.setState(prev => ({isDarkTheme: !prev.isDarkTheme}))
  }

  onSearchInput = event => {
    this.setState({searchInput: event.target.value})
  }

  closeBanner = () => {
    this.setState({isBannerVisible: false})
  }

  getData = async () => {
    this.setState({apiStatus: 'IN_PROGRESS'})
    const {searchInput} = this.state
    const jwtToken = Cookies.get('jwt_token')

    const url = `https://apis.ccbp.in/videos/all?search=${searchInput}`
    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }

    try {
      const response = await fetch(url, options)
      if (response.ok) {
        const data = await response.json()
        const fetchedData = data.videos.map(each => ({
          id: each.id,
          title: each.title,
          thumbnailUrl: each.thumbnail_url,
          channel: each.channel,
          viewCount: each.view_count,
          publishedAt: each.published_at,
        }))
        this.setState({videosList: fetchedData, apiStatus: 'SUCCESS'})
      } else {
        this.setState({apiStatus: 'FAILURE'})
      }
    } catch {
      this.setState({apiStatus: 'FAILURE'})
    }
  }

  renderVideosList = () => {
    const {videosList} = this.state
    if (videosList.length === 0) {
      return (
        <div className="no-video">
          <img
            src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-search-results-img.png" // updated
            alt="no videos"
            className="no-video-img"
          />
          <h1>No Search results found</h1>
          <p>Try different key words or remove search filter</p>
          <button
            type="button"
            onClick={this.getData}
            style={{color: '#ffffff'}} // ensures Login color consistency
          >
            Retry
          </button>
        </div>
      )
    }

    return (
      <ul className="videos-list">
        {videosList.map(each => (
          <li key={each.id} className="video-card">
            <Link to={`/videos/${each.id}`} className="video-link">
              <img
                src={each.thumbnailUrl}
                alt="video thumbnail"
                className="thumbnail"
              />
              <div className="video-info">
                <img
                  src={each.channel.profile_image_url}
                  alt="channel logo"
                  className="channel-logo"
                />
                <div>
                  <p className="title">{each.title}</p>
                  <p className="channel-name">{each.channel.name}</p>
                  <p className="views-date">
                    {each.viewCount} views • {each.publishedAt}
                  </p>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    )
  }

  renderLoader = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#0b69ff" height={50} width={50} />
    </div>
  )

  renderFailure = () => (
    <div className="failure-view">
      <img
        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png"
        alt="failure view"
        className="failure-img"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>We are having some trouble fetching videos. Please try again.</p>
      <button type="button" onClick={this.getData} style={{color: '#ffffff'}}>
        Retry
      </button>
    </div>
  )

  renderAllVideos = () => {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case 'IN_PROGRESS':
        return this.renderLoader()
      case 'SUCCESS':
        return this.renderVideosList()
      case 'FAILURE':
        return this.renderFailure()
      default:
        return null
    }
  }

  render() {
    const {searchInput, isBannerVisible, isDarkTheme} = this.state
    const homeBg = isDarkTheme ? '#181818' : '#ffffff'

    return (
      <div
        className="app-container"
        data-testid="home"
        style={{backgroundColor: homeBg}}
      >
        <Headers theme={isDarkTheme} toggleTheme={this.toggleTheme} />
        <div className="main-body">
          <div className="card1">
            <ul className="navItemsList">
              <li key="home">
                <Link to="/" className="side-link">
                  <MdHome className="icon" /> Home
                </Link>
              </li>
              <li key="trending">
                <Link to="/trending" className="side-link">
                  <FaFirefoxBrowser className="icon" /> Trending
                </Link>
              </li>
              <li key="gaming">
                <Link to="/gaming" className="side-link">
                  <SiYoutubegaming className="icon" /> Gaming
                </Link>
              </li>
              <li key="saved">
                <Link to="/saved-videos" className="side-link">
                  <MdPlaylistAdd className="icon" /> Saved Videos
                </Link>
              </li>
            </ul>

            <div className="sidebar-bottom">
              <p>CONTACT US</p>
              <div className="images">
                <img
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-facebook-logo-img.png"
                  alt="facebook logo"
                  className="icons"
                />
                <img
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-twitter-logo-img.png"
                  alt="twitter logo"
                  className="icons"
                />
                <img
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-linked-in-logo-img.png"
                  alt="linked in logo"
                  className="icons"
                />
              </div>
              <p>Enjoy! Now to see your channels and recommendations!</p>
            </div>
          </div>

          <div className="card2">
            {isBannerVisible && (
              <div
                className="inner"
                data-testid="banner"
                style={{
                  backgroundImage:
                    'url("https://assets.ccbp.in/frontend/react-js/nxt-watch-banner-bg.png")',
                }}
              >
                <img
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
                  className="logo"
                  alt="nxt watch logo"
                />
                <button
                  type="button"
                  data-testid="close"
                  className="cancel-button"
                  onClick={this.closeBanner}
                >
                  <GiCancel className="cancelMark" />
                </button>
                <p>Buy Nxt Watch Premium prepaid plans with UPI</p>
                <button type="button" className="getit">
                  GET IT NOW
                </button>
              </div>
            )}

            <div className="search-container">
              <input
                type="search"
                value={searchInput}
                onChange={this.onSearchInput}
                placeholder="Search"
                className="search-element"
              />
              <button
                onClick={this.getData}
                data-testid="searchButton"
                type="button"
              >
                <MdSearch className="search" />
              </button>
            </div>

            {this.renderAllVideos()}

            <Switch>
              <Route path="/trending" component={TrendingRoute} />
              <Route path="/gaming" component={GamingRoute} />
              <Route path="/saved-videos" component={SavedVideos} />
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

export default HomeRoute
